document.addEventListener('turbo:load', (eEvent) => {
  const autofocusedElements = document.querySelectorAll('input[autofocus]')
  if (autofocusedElements.length) {
    autofocusedElements[0].focus()
  }
})
